import { render, staticRenderFns } from "./DialogAddPButtons.vue?vue&type=template&id=5e19e15c&scoped=true&"
import script from "./DialogAddPButtons.vue?vue&type=script&lang=js&"
export * from "./DialogAddPButtons.vue?vue&type=script&lang=js&"
import style0 from "./DialogAddPButtons.vue?vue&type=style&index=0&id=5e19e15c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e19e15c",
  null
  
)

export default component.exports